<template>
  <div>
    <StaticInvoiceViewer v-if="static_invoice"
      v-bind="{invoice: static_invoice, configuration:configuration, rectified_inv:rectificative_invoice}" :key="invoice_id.toString()">
    </StaticInvoiceViewer>
  </div>
</template>

<script>
import StaticInvoiceViewer from "../components/StaticInvoiceViewer.vue";

import {ApiInvoiceableRepository} from '../modules/facturae/infra/ApiInvoiceableRepository'
import { ApiConfigurationRepository } from "@/modules/facturae/infra/ApiConfigurationRepository";

export default {
  components: {
    StaticInvoiceViewer
  },
  props:{
    invoice_id: {
      type: Number,
      required: true
    },
    companydb_id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      static_invoice: null,
      configuration: null,
      rectificative_invoice: null
    };
  },
  created() {
    this.fetchInvoice();
  },
  methods: {
    async fetchInvoice() {
      try {
        let invoiceable_repo = new ApiInvoiceableRepository()
        let config_repo = new ApiConfigurationRepository()
        if (this.invoice_id){
            this.static_invoice = await invoiceable_repo.find_by_id(this.invoice_id)
            this.configuration = await config_repo.get_configuration(this.companydb_id, this.static_invoice.type)
            if (this.static_invoice && this.static_invoice.rectificative && this.static_invoice.rectificative_info && this.static_invoice.rectificative_info.invoice_id) {
                this.rectificative_invoice = await invoiceable_repo.find_by_id(this.static_invoice.rectificative_info.invoice_id)
            }
        }
        else{
            this.static_invoice = null
        }
      } catch (error) {
        console.error('Error fetching invoice:', error);
      }
    }
  }
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
